import { ForgotPasswordForm } from '@/modules/Users/ForgotPassword.form';

const ForgotPassword = () => <ForgotPasswordForm />;

export default ForgotPassword;
